// @ts-check
import { graphql } from 'gatsby';
import React from 'react';

export const query = graphql`
	fragment MaterialUiImageFragment on Ozk_content_blockModular_blocksCopyContentImageImage_type {
		material_ui_icon {
			background_type
			background_color
			icon_color
			icon_name
		}
	}
`;


/**
 * @typedef {'none' | 'round' | 'rounded-square'} BackgroundType
 *
 * @typedef MaterialUiImageOptions
 * @property {string} icon_name
 * @property {BackgroundType} background_type
 * @property {string} background_color
 * @property {string} icon_color
 * @property {string} alt_text
 *
 * @typedef MaterialUiImageProps
 * @property {MaterialUiImageOptions} options
 * @property {string} height
 */
/** @type {import('~/types/React').ReactFC<MaterialUiImageProps>} */
const MaterialUiImage = ({ height, options }) => {
	if (!options) {
		return null;
	}

	const backgroundColor = options.background_type === 'none' ? 'transparent' : options.background_color;

	return (
		<span
			className="icon"
			aria-label={options.alt_text}
			title={options.alt_text}
			style={{
				borderRadius: getBorderRadius(options.background_type),
				backgroundColor,
				color: options.icon_color,
				fontSize: height,
			}}
		>
			{options.icon_name}
		</span>
	);
};

/**
 * Get the radius from the type.
 * @param {BackgroundType} type
 * @returns {import('csstype').Property.BorderRadius}
 */
function getBorderRadius(type) {
	switch (type) {
		case 'round':
			return '16rem';
		case 'rounded-square':
			return '6px';
		case 'none':
		default:
			return undefined;
	}
}

export default MaterialUiImage;
